import { createSelector } from 'reselect';
import { RootState } from 'MyTypes';
import { State } from './reducer';

export const selectAnalyticsState = (state: RootState): State => state.analytics;

export const selectAddressZips = createSelector(selectAnalyticsState, (analytics) => analytics.addressZips);
